module.exports = __webpack_public_path__ + "src/assets/img/car_security.e4b96761.jpg";